import { render, staticRenderFns } from "./ui-logo.vue?vue&type=template&id=5ee37f4e&scoped=true&"
import script from "./ui-logo.vue?vue&type=script&lang=js&"
export * from "./ui-logo.vue?vue&type=script&lang=js&"
import style0 from "./ui-logo.vue?vue&type=style&index=0&id=5ee37f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee37f4e",
  null
  
)

export default component.exports